/**
 * Keys the retired browser extension bridge left in localStorage.
 *
 * The bridge wrote the signed-in user's Clerk session token and profile here on every page view so
 * the extension could read them, and only ever cleared some of them (and only in browsers that
 * exposed `window.chrome`). Bearri no longer has an extension, so nothing should hold them.
 */
export const LEGACY_STORAGE_KEYS = [
  'bearri_clerk_token',
  'bearri_auth_timestamp',
  'bearri_user_data',
  'bearri_youtube_connected',
  'bearri_ext_banner_dismissed',
] as const;

/** Removes every legacy key. Storage can be missing or throw (private windows, blocked site data). */
export function purgeLegacyStorage(): void {
  let storage: Storage | undefined;
  try {
    storage = window.localStorage;
  } catch {
    return;
  }
  if (!storage) return;
  for (const key of LEGACY_STORAGE_KEYS) {
    try {
      storage.removeItem(key);
    } catch {
      /* One failed key must not stop the rest. */
    }
  }
}
